import { StyledEngineProvider } from "@mui/material";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { store } from "./store/store";
const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
	<Provider store={store}>
		<BrowserRouter>
		<StyledEngineProvider injectFirst>
			<App />
			</StyledEngineProvider>
		</BrowserRouter>
	</Provider>
);
